import React from "react";

// Matches the design's dropdown chevron exactly, used as a custom
// `suffixIcon` on every antd Select in this module so sizing/position is
// consistent and doesn't depend on antd's default arrow glyph.
const NPSChevronIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 6.5L8 10.5 12 6.5" stroke="#8496A8" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default NPSChevronIcon;
